export const exportPdfConfig = {
    stylesheets: [
        'https://cdn.ckeditor.com/ckeditor5/46.0.0/ckeditor5.css',
        'https://cdn.ckeditor.com/ckeditor5-premium-features/46.0.0/ckeditor5-premium-features.css',
        
    ],
    fileName: 'export-pdf-demo.pdf',
    converterOptions: {
        format: 'A4',
        margin_top: '20mm',
        margin_bottom: '20mm',
        margin_right: '20mm',
        margin_left: '20mm',
        page_orientation: 'portrait'
    },
    
};

export const exportWordConfig = {
    stylesheets: [
        'https://cdn.ckeditor.com/ckeditor5/46.0.0/ckeditor5.css',
        'https://cdn.ckeditor.com/ckeditor5-premium-features/46.0.0/ckeditor5-premium-features.css',
        
    ],
    fileName: 'export-word-demo.docx',
    converterOptions: {
        document: {
            orientation: 'portrait',
            size: 'A4',
            margins: {
                top: '20mm',
                bottom: '20mm',
                right: '24mm',
                left: '24mm'
            }
        }
    }
};